<template>
  <div class="Button">
    <slot></slot>
  </div>
</template>

<script>

// -----

export default {

}
</script>

<style scoped>
.Button {
  text-align: center;
  background-color: #00AEB0;
  border: 1px solid #00AEB0;
  border-radius: 23px;
  cursor: pointer;
  color: #FFFFFF;
  text-decoration: none;
  text-transform: uppercase;
  padding: 15px 50px;
  font-size: 14px;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
}
</style>